<template>
  <Modal @close="close">
    <div slot="modal-header">
      {{ systemApp.get('name') }}
    </div>
    <div class="d-flex flex-column font-color-primary">
      <div
        v-for="sys in cleanedSystem"
        :key="sys.id"
        class="sys-entry border-bottom"
        @click="onSystemSelected(sys)"
        v-html="sys.get('name')"
      />
    </div>  </Modal>
</template>

<script>
import Modal from '../atoms/Modal';
import SystemViewModal from './SystemViewModal';
export default {
  name: 'SystemApplicationDetailModal',
  components: { Modal },
  props: {
    systemApp: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {
    cleanedSystem: function() {
      let i = 0;
      let result = [];
      let sys = this.systemApp.get('systems');
      for (i = 0; i < sys.length; i++) {
        if (sys[i].get('visible')) {
          result.push(sys[i]);
        }
      }
      return result;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    onSystemSelected(system) {
      this.$modal.show(SystemViewModal, { system }, { height: 'auto', width: '95%' });
    },
  },
};
</script>

<style scoped>
.sys-entry {
  padding: 1rem 0;
  text-align: center;
  cursor: pointer;
}
</style>
